import React__default from 'react';
import { useIntl } from 'react-intl';

function useIntlShort() {
  var intl = useIntl();
  return React__default.useCallback(function (key, values) {
    if (!intl.messages[key]) {
      return key;
    }
    return intl.formatMessage({
      id: key
    }, values);
  }, [intl]);
}
function useIntlShortWithFallback() {
  var intl = useIntl();
  return React__default.useCallback(function (key, fallbackKey, values) {
    if (intl.messages[key]) {
      return intl.formatMessage({
        id: key
      }, values);
    }
    return intl.formatMessage({
      id: fallbackKey
    }, values);
  }, [intl]);
}

export { useIntlShort, useIntlShortWithFallback };
